import React from 'react';

import {
  Container, ContentTask, StatusName, TotalStatus,
} from './styles';

export default function FilterStatus({ optionsStatus, statusActived }) {
  return (
    <Container>
      {optionsStatus.map(option => (
        <ContentTask
          key={option.id}
          onClick={option.setStatus}
          isActive={option.id === statusActived}
        >
          {option.icon ? (
            <img style={{ marginBottom: '10px' }} src={option.icon} alt="Finalizado Status Tab" />
          ) : (
            <TotalStatus isActive={option.id === statusActived} color={option.hexColor}>
              {option.total}
            </TotalStatus>
          )}
          <StatusName isActive={option.id === statusActived} color={option.hexColor}>
            {option.label}
          </StatusName>
        </ContentTask>
      ))}
    </Container>
  );
}
